import type { TemplateListItem } from '@/lib/templates/types/template-list-item'
import type { TemplatesSort } from './types/templates-sort'

export const TEMPLATES_SORT_DEFAULT: TemplatesSort = 'az'

export const TEMPLATES_SORT_OPTIONS: ReadonlyArray<{ value: TemplatesSort; label: string }> = [
  { value: 'az', label: 'A to Z' },
  { value: 'za', label: 'Z to A' },
]

function compareTemplateName(left: string, right: string): number {
  return left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true })
}

/**
 * Reorders templates for the Sort control. Name-only — unlike Photos/Backgrounds, a template
 * carries no date field to drive a Newest/Oldest option.
 */
export function sortTemplates(
  templates: TemplateListItem[],
  sort: TemplatesSort
): TemplateListItem[] {
  return templates
    .map((template, index) => ({ template, index }))
    .sort((left, right) => {
      let cmp = compareTemplateName(left.template.templateName, right.template.templateName)

      if (sort === 'za') cmp = -cmp
      if (cmp !== 0) return cmp

      return left.index - right.index
    })
    .map(({ template }) => template)
}
